import { SideMenuComponent } from './side-menu.component';
import * as i0 from "@angular/core";
/**
 * Compatibility shell: SideMenuComponent is standalone, this module only re exports it for
 * the NgModule based page apps. Import the component directly in standalone contexts.
 */
export class SideMenuModule {
}
SideMenuModule.ɵfac = function SideMenuModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuModule)(); };
SideMenuModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SideMenuModule });
SideMenuModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [SideMenuComponent] });
